import { AppRouter } from "routes/AppRouter";
import "antd/dist/antd.css";
import "./App.css";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import { splitLink } from "services/apollo.service";

import { datadogRum } from "@datadog/browser-rum";
import { useEffect, useState } from "react";
import { Affix, Button } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
datadogRum.init({
  applicationId: "3b76cf32-dea4-4d18-b623-a2b693456b32",
  clientToken: "pub5e989cd99b4f36779340ad4413ddf031",
  site: "us5.datadoghq.com",
  service: "explorator",
  env: process.env.REACT_APP_BRANCH,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  premiumSampleRate: 100,
  trackUserInteractions: true,
  defaultPrivacyLevel: "allow",
});

datadogRum.startSessionReplayRecording();

const App: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  const handleClickScroll = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
  }, []);
  const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
  });
  return (
    <>
      <ApolloProvider client={client}>
        <AppRouter />
      </ApolloProvider>
      {isVisible ? (
        <Affix
          offsetBottom={30}
          style={{
            position: "absolute",
            right: "30px",
          }}
        >
          <Button
            style={{
              boxShadow: "-1px 0px 15px 8px #cccccca3",
            }}
            shape="circle"
            type="primary"
            icon={<ArrowUpOutlined />}
            onClick={handleClickScroll}
          ></Button>
        </Affix>
      ) : (
        ""
      )}
    </>
  );
};

export default App;
